import type { DocumentTypeSectionPayload } from '@Application/Organizations/Workflows/Actions/documentTypeSectionsFetched';
import DocumentTypeSectionFieldView from '@UI/Store/OrganizationWorkflows/Views/DocumentTypeSectionFieldView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One top-level section of a document type's template. `path` '' is the general fields section;
 * `isReevaluation` marks the sections the re-evaluation rewrites.
 */
class DocumentTypeSectionView {
	readonly path: string;
	readonly title: string;
	readonly isReevaluation: boolean;
	readonly fields: readonly DocumentTypeSectionFieldView[];

	constructor(payload: DocumentTypeSectionPayload) {
		this.path = payload.path;
		this.title = payload.title;
		this.isReevaluation = payload.isReevaluation;
		this.fields = payload.fields.map((field) => new DocumentTypeSectionFieldView(field));

		Object.freeze(this);
	}
}

export default DocumentTypeSectionView;
